import { Auth } from "aws-amplify";
import { HttpMainApi } from "../interface/main-api";
import { appConfig } from "../config/Config";
import { AES, enc } from "crypto-js";

const mainApi = new HttpMainApi();

export async function checkAuthenticated() {
  let result = false;
  await Auth.currentSession()
    .then(async (data) => {
      await Auth.currentAuthenticatedUser()
        .then((data) => {
          result = true;
        })
        .catch((err) => {
          result = false;
        });
    })
    .catch((err) => {
      result = false;
    });
  return result;
}

export async function getUserAttr() {
  try {
    if (!(await checkAuthenticated())) throw Error("user not loged in");
    const user = await Auth.currentAuthenticatedUser();
    const { attributes } = user;
    let rtn_pay_load = {
      id: user.username,
      name: attributes.name,
    };
    return rtn_pay_load;
  } catch (e) {
    return {
      id: "",
      name: "",
    };
  }
}

export async function checkPermission() {
  let admin_info: any = {
    isAdmin: false,
    is_super_admin: false,
    isSuperAdmin: false,
    company: "",
  };
  if (!(await checkAuthenticated())) return admin_info;
  const user = await Auth.currentAuthenticatedUser();
  const param: any = {
    command: "get_user_info",
    user_id: user.username,
  };
  const res = await mainApi.post(param);
  if (res.code === "200") {
    admin_info.isAdmin =
      res.response.user_info.is_admin !== undefined
        ? res.response.user_info.is_admin
        : false;
    admin_info.isSuperAdmin =
      res.response.user_info.is_super_admin !== undefined
        ? res.response.user_info.is_super_admin
        : false;
    admin_info.isPermission =
      res.response.user_info.is_permission !== undefined
        ? res.response.user_info.is_permission
        : false;
    admin_info.company = res.response.user_info.company;
  }
  return admin_info;
}

export async function setChatName(newChatName: string) {
  let loginUser = await Auth.currentAuthenticatedUser();
  let result = await Auth.updateUserAttributes(loginUser, {
    "custom:chat_name": newChatName,
  });
  return result;
}

export async function getChatName() {
  let loginUser = await Auth.currentAuthenticatedUser();
  const { attributes } = loginUser;
  if (
    attributes["custom:chat_name"] === undefined ||
    attributes["custom:chat_name"] === ""
  ) {
    return "";
  } else {
    return attributes["custom:chat_name"];
  }
}

export async function signOut() {
  try {
    await Auth.signOut();
    return true;
  } catch (error) {
    console.error("error signing out: ", error);
    return false;
  }
}

export async function setPicture(path: string) {
  let loginUser = await Auth.currentAuthenticatedUser();
  let result = await Auth.updateUserAttributes(loginUser, {
    picture: path,
  });
  return result;
}

export function getSession() {
  const encObjString = window.localStorage.getItem(appConfig.sessionName);

  if (!encObjString) return null;
  try {
    const bytes = AES.decrypt(encObjString, appConfig.seed);
    const decrypted = bytes.toString(enc.Utf8);
    let obj = JSON.parse(decrypted);
    if (Date.now() > obj.expire) {
      window.localStorage.removeItem(appConfig.sessionName);
      return false;
    } else {
      obj.expire = Date.now() + appConfig.sessionTimeout;
      const objString = JSON.stringify(obj);
      const encObjString = AES.encrypt(objString, appConfig.seed).toString();
      window.localStorage.setItem(appConfig.sessionName, encObjString);
    }

    return obj;
  } catch (error) {
    window.localStorage.removeItem(appConfig.sessionName);
    return null;
  }
}
